import React, { useEffect, useState } from 'react'
import EntityHeader from './EntityHeader'
import { Button, Card, CardBody, Container } from 'reactstrap'
import BackButton from "../../components/Common/BackButton";
import EntityTabs from './EntityTabs';
import EntityDataTable from './EntityDataTable';
import { getEntityScoreMeResponse } from "http/fundLync/entityAndAddress.helper";
import { isEmpty } from 'lodash';
import EntityBorrowingProfile from './EntityBorrowingProfile';
import EntityShareHoldingPattern from './EntityShareHoldingPattern';
import EntityDirectorInformation from './EntityDirectorInformation';
import { useParams } from 'react-router-dom';
import EntityAuditorDetails from './EntityAuditorDetails';
import { decryptedValue } from 'common/utility';
import Switch from "react-switch";
const SliderToggle = ({ checked, onChange }) => {
  return (
    <div 
      onClick={onChange} 
      style={{
        cursor: 'pointer',
        width: '125px',
        height: '30px',
        backgroundColor: checked ? '#4CAF50' : '#4CAF50',
        borderRadius: '15px',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        transition: 'background-color 0.3s ease'
      }}
    >
      <div 
        style={{
          flex: 1,
          textAlign: checked ? 'left' : 'right',
          color: '#fff',
          fontSize: '12px',
          transition: 'opacity 0.3s ease',
          opacity: checked ? 1 : 1,
          paddingRight: checked ? '0px' : '10px', 
          paddingLeft: checked ? '10px' : '0px',
        }}
      >
        {checked ? 'Consolidated' : 'Standalone'}
      </div>
      <div 
        style={{
          position: 'absolute',
          left: checked ? '73%' : '3%',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '30px',
          height: '30px',
          backgroundColor: '#fff',
          borderRadius: '50%',
          transition: 'left 0.3s ease'
        }}
      />
    </div>
  );
};

const EntityMoreInformation = () => {

  // All tabs to show
  const allTabs = [
    {
      key: 'profitLossStatement', //
      displayName: 'Income Statement'
    },
    {
      key: 'balanceSheet',
      displayName: 'Balance Sheet'
    },
    {
      key: 'ratioAnalysis',
      displayName: 'Ratios'
    },
    {
      key: 'cashFlow',
      displayName: 'Cash Flow'
    }
  ]
  const [activeTab, setActiveTab] = useState(allTabs[0])
  const [entityData, setEntityData] = useState([])
  const [columnsName, setColumns] = useState([])
  const [dataType, setDataType] = useState('STANDALONE');
  const [balanceSheetFilter, setBalanceSheetFilter] = useState('STANDALONE');
  const [profitLossStatementFilter, setProfitLossStatementFilter] = useState('STANDALONE');
  const [checked, setChecked] = useState(false); 
  // const [data, setData] = useState([])

  
  const urlParams = new URLSearchParams(window.location.search);
  const entityId = urlParams.get("id");
  const entityName = urlParams.get("entityName")
  const userData = decryptedValue(localStorage.getItem("user")) || {};
  const userObj = userData;
  const decodedId = entityId ? atob(entityId) : userObj.entityId;


  useEffect(() => {
    getEntityData()
  }, [activeTab, dataType, profitLossStatementFilter, balanceSheetFilter])

  const getEntityData = async () => {
    setEntityData([]);
    const bodyData = {
      entityId: decodedId,
      key: activeTab.key,
      filter: dataType,
      profitLossStatementFilter: profitLossStatementFilter,
      balanceSheetFilter: balanceSheetFilter
    }
    const entityInfo = await getEntityScoreMeResponse(bodyData)
    if (entityInfo.status) {
      setEntityData(entityInfo.data)
    } 
  }


  // Handle tab change
  const handleTab = (tab) => {
    setActiveTab(tab)
  }

  // const toggleDataType = () => {
  //   setDataType(dataType === 'STANDALONE' ? 'CONSOLIDATED' : 'STANDALONE');
  //   setChecked(!checked);
  // };
  const handleToggle = (tab) => {
    setDataType(tab);
  }
  
  const handleToggleprofitLossStatement = (tab) => {
    setProfitLossStatementFilter(tab);
  }

  const handleToggleBalanceSheetFilter = (tab) => {
    setBalanceSheetFilter(tab);
  }

  let data = []

  let columns = []

  const extractYear = (dateString) => {
    return dateString.split('-')[0];
  }
  
  if (!isEmpty(entityData) && !isEmpty(entityData.response) && !isEmpty(entityData.response[0]) && !isEmpty(entityData.response[0].data)) {
    let newColumns = []
    let tempCol = entityData.response[0].data.map((dataItem, index) => {
      let year = dataItem.filter((item) => item.key === 'year')
      let yearValue = extractYear(year[0].value)
      return yearValue
    })

    if (activeTab.key === 'ratioAnalysis') {
      newColumns = [
        {
          name: 'Title',
          selector: 'title',
          key: 'title',
          sortable: true,
        }
      ];
    } else {
      newColumns = [
        {
          name: 'Title (Amount Lac.)',
          selector: 'title',
          key: 'title',
          sortable: true,
        }
      ];
    }
    let tempColumns = tempCol.map((item, index) => {
      return {
        name: item,
        selector: item,
        key: item,
        sortable: true,
      }
    })

    columns = [...newColumns, ...tempColumns]
  }

  if (!isEmpty(entityData) && !isEmpty(entityData.response) && !isEmpty(entityData.response[0]) && !isEmpty(entityData.response[0].data)) {
    for (const element of entityData.response) {
      let tempData = {}
      const key = element['key']
      const dataItem = element
      const transformedData = {};
      // Iterate through the original data
      dataItem.data.forEach((row, index) => {
        row.forEach(item => {

          if (item.key === "year") return;

          if (!transformedData[item.displayName]) {
            transformedData[item.displayName] = {};
          }

          transformedData[item.displayName][columns[index + 1]['key']] = item.value;
        });
      });

      const finalData = Object.keys(transformedData).map(title => ({
        title,
        ...transformedData[title],
      }));
      tempData = {
        key: key,
        data: finalData
      }

      data = [...data, tempData]
    }
  }

  let directorList = !isEmpty(entityData) && !isEmpty(entityData.authorisedPeople) ? entityData.authorisedPeople.map((item, index) => {
    let [firstName, lastName] = item?item.name.split(" "):''
    let avatar = `${!isEmpty(firstName) ? firstName[0] : ''}${!isEmpty(lastName) ? lastName[0] : ''}`
    return {
      id: index + 1,
      name: item?.name,
      type: item?.type,
      dateOfAppointment: item?.dateOfAppointment,
      designation: item?.designation,
      avatar
    }

  }) : []

  let shareHoldingData = !isEmpty(entityData) && !isEmpty(entityData.shareholdingPatterns) ? entityData.shareholdingPatterns : {}

  let borrowingProfileData = !isEmpty(entityData) && !isEmpty(entityData.borrowingProfiles) ? entityData.borrowingProfiles : {}

  let auditorDetails = !isEmpty(entityData) && !isEmpty(entityData.auditorDetails) ? entityData.auditorDetails.map((item, index) => {
    return {
      id: index + 1,
      auditorFirmName: item.auditorFirmName,
      auditorOrMemberName: item.auditorOrMemberName,
      year: item.year,
    }
  }) : []

  return (
    <div className={entityName ? "page-content" : ""}>
    <Container fluid>
        {entityName ? <BackButton /> : null}
        <div className={entityName ? "vertical-scroll" : ""}>
            {entityName ? <EntityHeader entityData={entityData} /> : null}
            <Card style={{border:"none"}}>
              <CardBody className='px-0'>
                <EntityTabs activeTab={activeTab} handleTab={handleTab} allTabs={allTabs} />
                {activeTab.key === 'cashFlow' && (
                  <div className="toggle-switch-container">
                    <div className="toggle-switch">
                      <label
                        className={`switch-label ${dataType === "STANDALONE" ? "active" : ""}`}
                        onClick={() => handleToggle("STANDALONE")}
                        onKeyDown={(event) => { if (event.key === "Enter") handleToggle("STANDALONE"); }}
                        tabIndex={0} 
                      >
                        Standalone
                      </label>
                      <label
                        className={`switch-label ${dataType === "CONSOLIDATED" ? "active" : ""}`}
                        onClick={() => handleToggle("CONSOLIDATED")}
                        onKeyDown={(event) => { if (event.key === "Enter") handleToggle("CONSOLIDATED"); }}
                        tabIndex={0}
                      >
                        Consolidated
                      </label>
                      <div className={`slider1 ${dataType === "CONSOLIDATED" ? "slide-right" : ""}`}></div>
                    </div>
                  </div>
                )}
                {activeTab.key === 'profitLossStatement' && (
                    <div className="toggle-switch-container">
                      <div className="toggle-switch">
                        <label
                          className={`switch-label ${profitLossStatementFilter === "STANDALONE" ? "active" : ""}`}
                          onClick={() => handleToggleprofitLossStatement("STANDALONE")}
                          onKeyDown={(event) => { if (event.key === "Enter") handleToggleprofitLossStatement("STANDALONE"); }}
                          tabIndex={0} 
                        >
                          Standalone
                        </label>
                        <label
                          className={`switch-label ${profitLossStatementFilter === "CONSOLIDATED" ? "active" : ""}`}
                          onClick={() => handleToggleprofitLossStatement("CONSOLIDATED")}
                          onKeyDown={(event) => { if (event.key === "Enter") handleToggleprofitLossStatement("CONSOLIDATED"); }}
                          tabIndex={0}
                        >
                          Consolidated
                        </label>
                        <div className={`slider1 ${profitLossStatementFilter === "CONSOLIDATED" ? "slide-right" : ""}`}></div>
                      </div>
                    </div>
                )}
                {activeTab.key === 'balanceSheet' && (
                    <div className="toggle-switch-container">
                      <div className="toggle-switch">
                        <label
                          className={`switch-label ${balanceSheetFilter === "STANDALONE" ? "active" : ""}`}
                          onClick={() => handleToggleBalanceSheetFilter("STANDALONE")}
                          onKeyDown={(event) => { if (event.key === "Enter") handleToggleBalanceSheetFilter("STANDALONE"); }}
                          tabIndex={0} 
                        >
                          Standalone
                        </label>
                        <label
                          className={`switch-label ${balanceSheetFilter === "CONSOLIDATED" ? "active" : ""}`}
                          onClick={() => handleToggleBalanceSheetFilter("CONSOLIDATED")}
                          onKeyDown={(event) => { if (event.key === "Enter") handleToggleBalanceSheetFilter("CONSOLIDATED"); }}
                          tabIndex={0}
                        >
                          Consolidated
                        </label>
                        <div className={`slider1 ${balanceSheetFilter === "CONSOLIDATED" ? "slide-right" : ""}`}></div>
                      </div>
                    </div>
                )}
                <EntityDataTable data={data} columns={columns} />
              </CardBody>
            </Card>
            {entityName ? <EntityShareHoldingPattern shareHoldingData={shareHoldingData} /> : null}
            {entityName ? <EntityBorrowingProfile borrowingProfileData={borrowingProfileData} /> : null}
            {entityName ? <EntityDirectorInformation data={directorList} /> : null}
            <EntityAuditorDetails auditorDetails={auditorDetails} />
          </div>
        </Container>
      </div>
  )
}

export default EntityMoreInformation